import {useState} from "react";

// Components


// Scss
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/welcome.scss';
import '../assets/css/partnerPortal/sales.scss';

// Images
// import chevronDown from '../assets/img/partnerPortal/welcomePage/chevron-down.png';
// import chevronUp from '../assets/img/partnerPortal/welcomePage/chevron-up.png';


function PrimaryButtonBlue(props) {


  const text = props.text;
  const [link] = useState(props.link);
  const [className] = useState(props.className);
  const [classNameOfA] = useState(props.classNameOfA);
//   const [withoutIcon] = useState(props.withoutIcon);

  function getButton() {

    return <a href={link} target="_parent" className={classNameOfA + " d-flex justify-content-center"} >
                <div className={"primaryButtonBlue " + className}>  
                    <div className="buttonLettersPrimaryBlue">
                        {text}
                        {/* {withoutIcon ? "" : <img src={chevronDown} alt='...'  />} */}
                    </div>
                </div>
            </a>;
  }

  return (
    <>
        {/* <div className={"buttonSignUp mt-2 buttonHover " + className}>     */}
            {getButton()}
        {/* </div> */}
            
    </>
  );


}

export default PrimaryButtonBlue;

